var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0225 5.11756C21.3986 4.00781 20.7216 3.80369 19.343 3.72606C17.9659 3.63262 14.5029 3.59381 11.5029 3.59381C8.49706 3.59381 5.03269 3.63262 3.657 3.72462C2.28131 3.80369 1.60281 4.00637 0.973188 5.11756C0.330625 6.22587 0 8.13487 0 11.4957C0 11.4986 0 11.5001 0 11.5001C0 11.5029 0 11.5044 0 11.5044V11.5072C0 14.8537 0.330625 16.7771 0.973188 17.8739C1.60281 18.9837 2.27988 19.1849 3.65556 19.2784C5.03269 19.3589 8.49706 19.4063 11.5029 19.4063C14.5029 19.4063 17.9659 19.3589 19.3444 19.2798C20.723 19.1864 21.4001 18.9851 22.0239 17.8754C22.6723 16.7786 23 14.8552 23 11.5087C23 11.5087 23 11.5044 23 11.5015C23 11.5015 23 11.4986 23 11.4972C23 8.13487 22.6722 6.22587 22.0225 5.11756Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 15.8126V7.18762L15.8125 11.5001L8.625 15.8126Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePlay);
export default __webpack_public_path__ + "static/media/youtube-play.e9bc6089401f15b8e57a0b7142f1cd7e.svg";
export { ForwardRef as ReactComponent };